











import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import TextInput from '@/components/input/TextInput.vue';
import StringUtils from '@/utils/StringUtils';

@Component({
    components: {TextInput},
    mixins: [InputMixin]
})
export default class SelectInput extends Mixins<InputMixin>(InputMixin) {
    @Prop({default: false}) private readonly filterable: boolean;
    @Prop({default: 'codeValue'}) private readonly valueName: string;
    @Prop({default: 'codeLabel'}) private readonly labelName: string;
    @Prop({default: ''}) private readonly deletedPropertyName: string;
    @Prop({default: () => []}) private readonly options: any[];

    get elements() {
        return this.options;
    }

    get isFilterable() {
        return this.filterable;
    }

    public onChangeInput(data: any) {
        if (this.isReadOnly) {
            return;
        }

        this.$emit('input', data);
        if (this.changeDetectable) {
            this.$store.commit('commitValue', {
                itemId: this.getId,
                value: data,
                originValue: this.originValue
            });
        }
    }

    public focus() {
        const conponent: any = this.$refs.elementRef;
        conponent.focus();
    }

    public isDeleted(deleted: string) {
        if (!StringUtils.hasValue(deleted)) {
            return false;
        }

        return deleted === 'Y';
    }
}
